import { Outlet } from 'react-router-dom';
import { observer } from 'mobx-react-lite';

import { CreditLogProvider } from 'contexts/credit_log_context';
import { PaymentProvider } from 'contexts/payment_context';

import Stack from '@mui/joy/Stack';
import useAuth from 'hooks/useAuth';

import BreadcrumbLink from 'components/BreadcrumbLink';
const BreadCrumbs = () => {
    const { currentUser } = useAuth();

    //         <Typography

            // <Typography level="title-lg">Calendar Settings</Typography>
            // <Typography level="title-lg"><Link to={"/settings/calendar/preview"}>Preview</Link></Typography>

    return (
        <Stack direction="row"
            spacing={1}>
            { currentUser.has_calendar &&
            <BreadcrumbLink to={"/account/calendar"}
                prefix={"/account/calendar"}
                iconName="CalendarMonth">Calendar</BreadcrumbLink> }
            <BreadcrumbLink to={"/account/calendar/settings"}
                prefix={"/account/calendar"}
                iconName="EditCalendar">Calendar Settings</BreadcrumbLink>

        </Stack>
    );
};


const AccountContainer = observer(() => {

    return (

        <CreditLogProvider>
            <PaymentProvider>
                <Stack>
                    <Stack
                        direction="row"
                        justifyContent="space-between"
                        borderTop={1}
                       borderColor="divider"
                        sx={{
                                left: 0,
                                display: 'flex',
                                zIndex: 800,
                                borderTop: 1,
                            }}
                        py={1}
                    >
                        <Stack
                            direction="row"
                            justifyContent="space-between"
                            spacing={1}
                            mx={2}
                            width="100%"
                            alignItems="center">

                            <BreadCrumbs />

                        </Stack>
                    </Stack>
                    <Outlet />
                </Stack>
            </PaymentProvider>
        </CreditLogProvider>

    );

});



export default AccountContainer;
